<app-supplier-round-list-ssy1230detail [state]="viewState.Create"></app-supplier-round-list-ssy1230detail>